// Sets --fc-error-mx/my (-0.5..0.5) and --fc-error-sx/sy (0..100%) on
// [data-fc-error-page]; SCSS reads them for the parallax + spotlight.
export function initErrorPage(doc: Document = document): void {
  const page = doc.querySelector<HTMLElement>('[data-fc-error-page]');
  if (!page) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let raf = 0;
  let mx = 0;
  let my = 0;
  let sx = 50;
  let sy = 50;

  page.addEventListener('pointermove', (event) => {
    const rect = page.getBoundingClientRect();
    const xRatio = (event.clientX - rect.left) / rect.width;
    const yRatio = (event.clientY - rect.top) / rect.height;
    mx = xRatio - 0.5;
    my = yRatio - 0.5;
    sx = xRatio * 100;
    sy = yRatio * 100;
    if (!raf) raf = requestAnimationFrame(apply);
  });

  function apply(): void {
    raf = 0;
    page.style.setProperty('--fc-error-mx', mx.toFixed(3));
    page.style.setProperty('--fc-error-my', my.toFixed(3));
    page.style.setProperty('--fc-error-sx', `${sx.toFixed(1)}%`);
    page.style.setProperty('--fc-error-sy', `${sy.toFixed(1)}%`);
  }
}
